import { ClickEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow, StringUtil } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";
import { OrderTabView } from "../OrderTabView";
import { AutogenLayoutMobileCommMessageTable } from "./autogen/AutogenLayoutMobileCommMessageTable";

export class MobileCommMessageTable extends AutogenLayoutMobileCommMessageTable {

    tableMcMessageOnRowDisplay(event: TableRowDisplayEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        const labelMessageType = event.getTableRow().findComponentById("labelMessageType") as Label;
        const labelDriverFullName = event.getTableRow().findComponentById("labelDriverFullName") as Label;
        const labelMCUnitNo = event.getTableRow().findComponentById("labelMCUnitNo") as Label;
        const labelOrderId = event.getTableRow().findComponentById("labelOrderId") as Label;

        labelOrderId.addUnderlineWhenMouseOver();
        const msgSendingStatus = modelRow.get("msg_sending_status");
        const rowType = modelRow.get("row_type");

        switch (modelRow.get("message_type")) {
            case "I": {
                this.setImageAttributes(event, "I", msgSendingStatus);
                break;
            }
            case "O": {
                this.setImageAttributes(event, "O", msgSendingStatus);
                break;
            }
        }

        if (!StringUtil.isEmptyString(modelRow.get("driver_id"))) {
            CommonTooltips.setTooltipContentLayout(labelDriverFullName, modelRow.get("driver_id"), "lme/dispatch/asset/DriverQuickInfo", { minWidth: 128, minHeight: 140 });
        }

        if (!StringUtil.isEmptyString(modelRow.get("mc_unit_no"))) {
            CommonTooltips.setTooltipContentLayout(labelMCUnitNo, modelRow.get("mc_unit_no"), "lme/dispatch/mobilecomm/McUnitQuickInfo", { minWidth: 128, minHeight: 140 });
        }

        this.setupMessageText(event);

    }

    private setImageAttributes(event: TableRowDisplayEvent, messageType: string, status: string) {
        const labelStatus = event.getTableRow().findComponentById("labelStatus") as Label;
        const image = this.getImageToDisplay(event, messageType, status);

        if (image == null)
            return;

        image.visible = true;
        if (status == "-1") {
            image.imageColor = "blue";
            labelStatus.text = image.tooltip = "Scheduled";
        }
        else if (status == "0") {
            image.imageColor = "yellow";
            labelStatus.text = image.tooltip = null;
        }
        else if (status == "1") {
            image.color = "yellow";
            labelStatus.text = image.tooltip = "Network";
        }
        else if (status == "2" || status == "3") {
            image.imageColor = "blue";
            labelStatus.text = image.tooltip = "Sent";
        }
        else if (status == "100" || status == "150") {
            image.imageColor = "darkgreen";
            labelStatus.text = image.tooltip = "Arrived";
        }
        else if (status == "200") {
            image.imageColor = "primary";
            labelStatus.text = image.tooltip = "Read";
        } else {
            image.imageColor= "red";
            labelStatus.text = image.tooltip = "Failed";
        }
    }

    private getImageToDisplay(event: TableRowDisplayEvent, messageType: string, status: string) : Label {
        if (messageType == "I" && status == "99") {
            return event.getTableRow().findComponentById("messageIncomingOutlined") as Label;
        } else if (messageType == "I" && status != "99") {
            return event.getTableRow().findComponentById("messageIncomingFilled") as Label;
        }
        else if (messageType == "O" && status == "99") {
            return event.getTableRow().findComponentById("messageOutgoingOutlined") as Label;
        }
        else if (messageType == "O" && status != "99") {
            return event.getTableRow().findComponentById("messageOutgoingFilled") as Label;
        }

        return null;
    }

    private setupMessageText(event: TableRowDisplayEvent){
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const labelText = tableRow.findComponentById("labelMessageText") as Label;
        labelText.tooltip = modelRow.get("message_text");

    }

    orderNumberOnClick(event: ClickEvent) {
        OrderTabView.navigateTo({ key: (event.target as Label).text, newTab: true });
    }



}
